/**
 * Mapping of UI field names to API field names
 * UI field name (key) -> API field name (value)
 */
export const fieldApiMap = {
  name: 'full_name',
  jobTitle: 'primary_active_position.job_title',
  company: 'primary_active_position.organization',
  contactOf: 'importers',
  companySize: 'primary_active_position.company_size',
  companyFunding: 'primary_active_position.current_state',
  linkedinProfile: 'linkedin_url',
  linkedinTagline: 'linkedin_tagline',
  workEmail: 'work_emails',
  personalEmail: 'personal_emails',
  location: 'location.name',
  seniority: 'seniority',
  yearsOfExperience: 'years_of_experience',
  yearsInCurrentCompany: 'primary_active_position.duration',
  industry: 'primary_active_position.industry_tags',
  list: 'shared_list',
  tags: 'tags',
  notes: 'notes',
  source: 'sources',
  firstSeen: 'added_at',
  addedBy: 'added_to_shared_list_by.user.name',
  addedDate: 'added_to_shared_list_by.created_at',
  jobApplications: 'job_applications_count',
  talentNetworkSignup: 'signup_info',
  signupDate: 'signup_info.signup_date',
  preferredJobFunction: 'signup_info.job_functions',
  levelOfExperience: 'signup_info.seniorities',
  preferredLocation: 'signup_info.location_preferences',
  workEnvironment: 'signup_info.work_environments',
  jobSearchStatus: 'signup_info.job_search_status',
  resume: 'signup_info.resume_url',
  website: 'signup_info.website_url',
  industries: 'signup_info.industries',
  jobAlerts: 'signup_info.has_job_alerts',
  jobAlertsKeywords: 'signup_info.job_alert_keywords',
};

/**
 * Set of all field names derived from fieldApiMap
 */
export const fields = new Set(Object.keys(fieldApiMap));

/**
 * Fields that should be hidden when Talent Network is not enabled
 */
export const tnHiddenColumns = new Set([
  'talentNetworkSignup',
  'signupDate',
  'preferredJobFunction',
  'levelOfExperience',
  'preferredLocation',
  'workEnvironment',
  'jobSearchStatus',
  'resume',
  'jobAlerts',
  'jobAlertsKeywords',
  'website',
]);

/**
 * Reverse mapping: API field names to UI field names
 * Generated from fieldApiMap for quick lookups
 */
const apiToUiFieldMap = Object.entries(fieldApiMap).reduce((acc, [uiField, apiField]) => {
  acc[apiField] = uiField;
  return acc;
}, {});

/**
 * Serialize a UI field name to its corresponding API field name
 * @param {string} uiFieldName - The field name used in the UI
 * @returns {string|null} - The corresponding API field name, or null if not found
 */
export const serializeFieldName = (uiFieldName) => fieldApiMap[uiFieldName] || null;

/**
 * Deserialize an API field name to its corresponding UI field name
 * @param {string} apiFieldName - The field name from the API
 * @returns {string|null} - The corresponding UI field name, or null if not found
 */
export const deserializeFieldName = (apiFieldName) => apiToUiFieldMap[apiFieldName] || null;
